import z from "zod";
import { environmentsId, projectsId } from "../../db_gen";
import { zodName } from "../../utils";

const environmentCreateUpdateSchema = z.object({
  name: zodName(),
});
export type EnvironmentCreateUpdateSchema = z.infer<typeof environmentCreateUpdateSchema>;

export default {
  create: z.object({
    projectId: projectsId,
    data: environmentCreateUpdateSchema,
  }),
  update: z.object({
    environmentId: environmentsId,
    data: environmentCreateUpdateSchema,
  }),
  delete: z.object({
    projectId: projectsId,
    environmentId: environmentsId,
  }),
};
